// client/src/data/faqData.js
// ─────────────────────────────────────────────────────────────
// 셀프애드 FAQ 콘텐츠
// 이 파일만 수정하면 /faq 페이지에 바로 반영됩니다.
//
// 한 항목 = 하나의 질문/답변
//   side     : 'influencer' | 'marketer' | 'common'  (입장 분류)
//   category : 화면에서 묶이는 소분류 라벨
//   q        : 질문 한 줄
//   a        : 답변. 문단을 나누려면 빈 줄(\n\n)로 구분
//   id       : 고유값 (중복 금지)
// ─────────────────────────────────────────────────────────────

const faqItems = [
  // ══════════ 광고주 ══════════

  // ── 비용 · 포인트 ──
  {
    id: 'mkt-fee',
    side: 'marketer',
    category: '비용 · 포인트',
    q: '셀프애드를 이용할 때 수수료나 비용은 얼마나 드나요?',
    a: '모집하는 인플루언서 3명당 5,000원의 수수료만 부과되어, 부담 없이 마케팅을 시작할 수 있어요.\n\n결제 수단인 포인트는 1포인트가 현금 1원으로 환산됩니다. (부가세 별도)\n\n함께 협업할 인플루언서 규모에 따라 프로젝트 제작 비용을 달리 책정해야 합니다. 너무 적은 포인트로 프로젝트를 만들면 인플루언서 모집이 이루어지지 않을 수 있어요.',
  },
  {
    id: 'mkt-price',
    side: 'marketer',
    category: '비용 · 포인트',
    q: '인플루언서 규모나 분야별 단가를 알 수 있을까요?',
    a: '문의하기로 연락 주시면 셀프애드에 가입된 인플루언서의 평균 단가를 확인하실 수 있어요.\n\n다만 특정 인플루언서의 단가는 확인이 어렵습니다. 셀프애드는 크리에이터의 자유로운 활동을 보장합니다.',
  },
  {
    id: 'mkt-charge-once',
    side: 'marketer',
    category: '비용 · 포인트',
    q: '포인트 충전이나 환불을 여러 건 동시에 신청할 수 있나요?',
    a: '충전과 환불 모두 한 번에 1건씩만 진행할 수 있어요.\n\n‘입금 대기 중’이거나 ‘환불 처리 중’인 상태에서는 새 신청 폼이 나타나지 않습니다. 기존 요청을 취소하거나 처리가 끝난 뒤 다시 진행해 주세요.',
  },

  // ── 프로젝트 운영 ──
  {
    id: 'mkt-types',
    side: 'marketer',
    category: '프로젝트 운영',
    q: '어떤 형태의 광고 프로젝트를 진행할 수 있나요?',
    a: '비즈니스 특성에 맞춘 4가지 유형을 지원합니다.\n\n제품 제공 — 브랜드나 제조사가 재고를 인플루언서에게 직접 배송해 사용 후기를 받습니다.\n\n제품 미제공 — 인플루언서가 제품을 직접 구매해 리뷰하며 콘텐츠의 진정성을 높입니다.\n\n장소 방문 — 카페·식당·체험 공간 등 오프라인 매장을 인플루언서가 직접 방문해 체험합니다.\n\n자율 형식 — 모바일 게임 사전예약, 온라인 강의처럼 무형의 서비스나 자유로운 홍보에 활용합니다.',
  },
  {
    id: 'mkt-contract-start',
    side: 'marketer',
    category: '프로젝트 운영',
    q: '마음에 드는 인플루언서를 선정했어요. 계약은 언제 시작되나요?',
    a: '인플루언서를 선정하면 해당 인플루언서에게 알림이 전송되고, 48시간 이내에 수락하면 계약이 시작됩니다.\n\n인플루언서가 수락하지 않으면 계약은 성립되지 않아요.',
  },

  // ── 정산 · 결산 ──
  {
    id: 'mkt-cps',
    side: 'marketer',
    category: '정산 · 결산',
    q: 'CPS(Cost Per Sale) 리워드는 무엇이고, 정산은 어떻게 이뤄지나요?',
    a: 'CPS는 인플루언서의 콘텐츠를 통해 유입된 실제 구매 고객 1명당 추가 리워드를 지급하는 성과 기반 보상이에요.\n\n스마트스토어, 자사몰(UTM 파라미터), 쿠팡 파트너스 채널에서 설정할 수 있으며, 미리 설정한 보증금 범위 안에서만 광고비가 차감됩니다.\n\n결산이 끝난 뒤 사용하지 않은 보증금 잔액은 전액 광고주 포인트로 자동 환원되므로, 성과가 낮아도 예산 손실 걱정이 없습니다.',
  },
  {
    id: 'mkt-settle-miss',
    side: 'marketer',
    category: '정산 · 결산',
    q: 'CPS 결산일에 결산을 깜빡하면 어떻게 되나요?',
    a: '결산일 기준 7일 이내에 직접 결산하지 않으면, 시스템이 실제 유입 고객 수를 확인하지 않고 모든 인플루언서에게 ‘최대 금액’을 균등 지급합니다.\n\n보증금이 가장 많이 차감되는 경우이니, 반드시 7일 이내에 직접 결산하시길 권장합니다.',
  },

  // ── 결과물 · 검수 ──
  {
    id: 'mkt-reject',
    side: 'marketer',
    category: '결과물 · 검수',
    q: '인플루언서의 결과물이 가이드라인에 맞지 않으면 어떻게 처리하나요?',
    a: '결과물이 요청사항을 충족하지 못했다면 ‘반려’를 누르고 수정이 필요한 사유를 명확히 입력해 주세요.\n\n반려된 건은 즉시 셀프애드팀으로 이관되어, 객관적인 제3자 입장에서 한 번 더 검토해 공정하게 관리합니다.',
  },
  {
    id: 'mkt-reject-reason',
    side: 'marketer',
    category: '결과물 · 검수',
    q: '결과물을 반려할 때 사유를 대충 적어도 되나요?',
    a: '‘내용이 부족합니다’처럼 모호하게 적으면 안 됩니다.\n\n반려 시 즉시 셀프애드팀으로 이관되어 제3자 검토를 거치기 때문에, ‘해시태그 #제품명 누락’처럼 명확한 수정 기준을 적어주셔야 합니다.',
  },

  // ══════════ 인플루언서 ══════════

  // ── 가입 · 자격 ──
  {
    id: 'inf-follower',
    side: 'influencer',
    category: '가입 · 자격',
    q: '팔로워가 많지 않아도 가입하고 활동할 수 있나요?',
    a: '네, 가능합니다. 셀프애드는 팔로워 1,000명~10만 명의 나노·마이크로 인플루언서가 활동하기에 가장 적합하게 설계됐어요.\n\n광고주들은 형식적인 대형 채널보다 콘텐츠의 진정성이 살아있는 작은 채널을 선호하는 경향이 있어 선정 확률이 높습니다.\n\n인스타그램, 유튜브, 블로그, 틱톡 중 단 하나의 계정만 운영해도 가입과 활동이 가능합니다.',
  },
  {
    id: 'inf-apply-now',
    side: 'influencer',
    category: '가입 · 자격',
    q: '회원가입을 방금 마쳤는데, 바로 프로젝트에 지원할 수 있나요?',
    a: '가입 직후 즉시 지원은 어렵습니다.\n\n운영팀이 가입 시 첨부한 SNS 증빙 이미지(프로필 화면 또는 게시물 캡처)로 계정 소유권과 팔로워를 직접 검증해요. 영업일 1일 이내 승인이 끝나면 활동을 시작할 수 있습니다.',
  },

  // ── 활동 · 보상 ──
  {
    id: 'inf-reward-when',
    side: 'influencer',
    category: '활동 · 보상',
    q: '결과물을 제출하면 보상(포인트)은 언제 지급되나요?',
    a: '결과물 제출 후 광고주가 승인하면 약속된 포인트가 즉시 자동 입금됩니다.\n\n광고주가 검수하지 않더라도 제출 마감일 기준 7일이 지나면 시스템이 자동 승인 처리해 입금하므로, 미입금 위험이 없어요.',
  },
  {
    id: 'inf-cps',
    side: 'influencer',
    category: '활동 · 보상',
    q: 'CPS(추가 보상) 프로젝트에서 수익을 얻으려면 어떻게 해야 하나요?',
    a: 'CPS가 적용된 프로젝트에서는 제공받은 ‘전용 추적 URL’을 반드시 사용해야 합니다.\n\n이 추적 URL을 게시물 본문이나 프로필 링크 등에 노출해야만 유입된 구매자를 추적해 건당 추가 리워드를 받을 수 있어요.\n\n추적 URL을 빠뜨리면 실제 구매가 일어나도 추적이 불가능해 추가 보상을 받을 수 없으니 주의하세요.',
  },

  // ── 프로젝트 참여 ──
  {
    id: 'inf-multi',
    side: 'influencer',
    category: '프로젝트 참여',
    q: '한 번에 여러 프로젝트를 동시에 진행해도 되나요?',
    a: '네, 동시 참여가 가능합니다.\n\n다만 무제한은 아니며, 최대 10개까지 동시에 진행할 수 있어요.',
  },
  {
    id: 'inf-delay',
    side: 'influencer',
    category: '프로젝트 참여',
    q: '광고주의 제품 배송이 늦어 제출 마감일을 놓칠 것 같아요.',
    a: '마감일이 지나면 결과물 제출 자체가 불가능해집니다.\n\n제품 배송 지연처럼 인플루언서 과실이 아닌 상황이라면, 마감일이 지나기 전에 반드시 셀프애드팀에 문의해 일정을 조율하셔야 합니다.',
  },

  // ── 환전 · 정산 ──
  {
    id: 'inf-exchange',
    side: 'influencer',
    category: '환전 · 정산',
    q: '적립한 포인트의 현금 환전 기준과 절차가 궁금해요.',
    a: '누적 포인트가 5,000pt 이상이면 환전을 신청할 수 있고, 신청일 기준 영업일 1~3일 이내에 등록한 계좌로 입금됩니다.\n\n환전을 위해서는 가입 시 세금 신고 근거가 되는 ‘프리랜서 계약’과 ‘계약자 본인 명의 통장’ 등록을 마쳐야 해요.\n\n환전 시에는 세법에 따른 3.3% 세금과 플랫폼 운영 수수료를 합쳐 총 10%가 차감된 금액(90%)이 최종 정산됩니다.',
  },
  {
    id: 'inf-name',
    side: 'influencer',
    category: '환전 · 정산',
    q: '개명으로 예금주명과 가입 시 계약자명이 달라요. 직접 수정할 수 있나요?',
    a: '직접 변경은 불가능합니다.\n\n수익금(사업소득) 정산은 법적으로 프리랜서 계약자 본인 명의 통장으로만 가능해, 두 이름이 다르면 환전 신청이 되지 않아요. 이 경우 문의하기로 셀프애드팀에 계약자명 변경을 요청해 주세요.',
  },
];

export default faqItems;
